import { render } from "./JobListings.vue?vue&type=template&id=07cd5add&scoped=true"
import script from "./JobListings.vue?vue&type=script&lang=js"
export * from "./JobListings.vue?vue&type=script&lang=js"

import "./JobListings.vue?vue&type=style&index=0&id=07cd5add&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cd5add"]])

export default __exports__